/**
 *  确保在每一个动画帧中，函数fn只会执行一次，避免因为频繁执行导致性能问题
 */
export function rafThrottle(fn: Function) {
  let lock = false;
  return function (this: any, ...args: any[]) {
    if (lock) return;
    lock = true;
    window.requestAnimationFrame(() => {
      fn.apply(this, args);
      lock = false;
    });
  };
}

/**
 * 确保在延迟时间内，如果函数fn被多次调用，只会执行一次
 */
export function debounce(fn: Function, delay = 200) {
  let timer: any = null;
  return function (this: any, ...args: any[]) {
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}